<div class="label-preview-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>QR Label Vorschau</h2>
    <button mat-icon-button (click)="close()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="dialog-content">
    <div *ngIf="loading" class="loading-container">
      <mat-spinner></mat-spinner>
      <p>Label wird geladen...</p>
    </div>

    <div *ngIf="error" class="error-container">
      <mat-icon color="warn">error</mat-icon>
      <p>{{ error }}</p>
      <button mat-raised-button color="primary" (click)="loadLabelPreview()">
        Erneut versuchen
      </button>
    </div>

    <div *ngIf="!loading && !error" class="preview-container space-y-4">
      <!-- Tailwind Card Preview (matching template layout) -->
      <div class="bg-white shadow rounded-lg p-4 border border-gray-200" style="max-width: 140mm; width: 120mm;">
        <!-- Header: Logo + Client ID (matching template) -->
        <div class="flex items-start justify-between mb-2" style="margin-bottom: 3mm;">
          <div style="width: 70%;">
            <img [src]="logoUrl" alt="Logo" style="max-height: 84mm; max-width: 200px; width: auto; height: auto;" />
          </div>
          <div style="width: 30%; text-align: right;">
            <div class="text-[8px] font-semibold text-gray-700">ID: {{ systemId }}</div>
          </div>
        </div>
        
        <!-- Main Content: Indicator Info + QR Code (matching template) -->
        <div class="flex flex-row gap-4 items-start">
          <div class="flex-1">
            <div class="space-y-1">
              <div class="text-[10px] font-semibold leading-tight" style="font-size: 10px;">{{ indicatorName }}</div>
              <div class="text-[12px] font-bold text-gray-900" style="font-size: 12px; font-weight: bold; margin-bottom: 1.5mm; color: #333;">{{ indicatorType }}</div>
              <div class="text-[26px] font-semibold" style="font-size: 26px;">{{ indicatorNumber }}</div>
              <!-- Symbol with color mask (matching template) -->
              <div *ngIf="symbolUrl" class="mt-1" style="margin-top: 1mm;">
                <div *ngIf="symbolColor" 
                     class="inline-block"
                     [style.background-color]="symbolColor"
                     [style.mask-image]="'url(' + symbolUrl + ')'"
                     [style.mask-size]="'contain'"
                     [style.mask-repeat]="'no-repeat'"
                     [style.mask-position]="'center'"
                     [style.-webkit-mask-image]="'url(' + symbolUrl + ')'"
                     [style.-webkit-mask-size]="'contain'"
                     [style.-webkit-mask-repeat]="'no-repeat'"
                     [style.-webkit-mask-position]="'center'"
                     style="width: 20px; height: 20px;">
                </div>
                <img *ngIf="!symbolColor" 
                     [src]="symbolUrl" 
                     alt="Symbol" 
                     class="h-5 w-5 object-contain" />
              </div>
            </div>
          </div>
          <div class="shrink-0 flex items-center justify-center">
            <img [src]="qrImgUrl" alt="QR" class="h-40 w-40 object-contain" style="width: 25mm; height: 25mm;" />
          </div>
        </div>
        
        <!-- Footer (matching template) -->
        <div class="text-center text-[6px] text-gray-500 mt-2" style="text-align: center; font-size: 6px; color: #777; margin-top: 2mm;">SBK1 - {{ today | date:'dd.MM.yyyy' }}</div>
      </div>

      <!-- Exact HTML (print) preview below, in iframe -->
      
    </div>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="close()">Schließen</button>
    <button 
      mat-raised-button 
      color="primary" 
      (click)="printLabel()"
      [disabled]="loading || !!error || !htmlContent">
      <mat-icon>print</mat-icon>
      Drucken
    </button>
  </div>
</div>


